if (!Intl.PluralRules) {
  require('@formatjs/intl-pluralrules/polyfill')
  require('@formatjs/intl-pluralrules/dist/locale-data/en')
  require('@formatjs/intl-pluralrules/dist/locale-data/de')
  require('@formatjs/intl-pluralrules/dist/locale-data/da')
  require('@formatjs/intl-pluralrules/dist/locale-data/es')
  require('@formatjs/intl-pluralrules/dist/locale-data/zh')
}

if (!Intl.RelativeTimeFormat) {
  require('@formatjs/intl-relativetimeformat/polyfill')
  require('@formatjs/intl-relativetimeformat/dist/locale-data/en')
  require('@formatjs/intl-relativetimeformat/dist/locale-data/de')
  require('@formatjs/intl-relativetimeformat/dist/locale-data/da')
  require('@formatjs/intl-relativetimeformat/dist/locale-data/es')
  require('@formatjs/intl-relativetimeformat/dist/locale-data/zh')
}

import en from './translations/en.json'
import da from './translations/da.json'
import de from './translations/de.json'
import es from './translations/es.json'
import zho from './translations/zho.json'
import sv from './translations/sv.json'
import no from './translations/no.json'
import vtmEn from './translations/en.voicetome.json'
import vtmDa from './translations/da.voicetome.json'
import vtmDe from './translations/de.voicetome.json'
import vtmEs from './translations/es.voicetome.json'
import vtmZho from './translations/zho.voicetome.json'
import vtmSv from './translations/sv.voicetome.json'
import vtmNo from './translations/no.voicetome.json'

const formatTranslationMessages = (locale, messages) => {
  const defaultFormattedMessages =
    locale !== defaultLocale ? formatTranslationMessages(defaultLocale, en) : {}
  return Object.keys(messages).reduce((formattedMessages, key) => {
    const formattedMessage =
      !messages[key] && locale !== defaultLocale
        ? defaultFormattedMessages[key]
        : messages[key]
    return Object.assign(formattedMessages, { [key]: formattedMessage })
  }, {})
}

const mergeMessages = (originals, overwrites) => {
  return {
    ...originals,
    ...overwrites,
  }
}

const defaultLocale = 'en'

const supportedLocales = {
  en: 'English',
  da: 'Dansk',
  de: 'Deutsch',
  sv: 'Svenska',
  no: 'Norsk',
  es: 'Español',
  zho: '中国人',
}

const translationMessages = {
  voicearchive: {
    en: formatTranslationMessages('en', en),
    da: formatTranslationMessages('da', da),
    de: formatTranslationMessages('de', de),
    es: formatTranslationMessages('es', es),
    zho: formatTranslationMessages('zho', zho),
    sv: formatTranslationMessages('sv', sv),
    no: formatTranslationMessages('sv', no),
  },
  voicetome: {
    en: formatTranslationMessages('en', mergeMessages(en, vtmEn)),
    da: formatTranslationMessages('da', mergeMessages(da, vtmDa)),
    de: formatTranslationMessages('de', mergeMessages(de, vtmDe)),
    es: formatTranslationMessages('es', mergeMessages(es, vtmEs)),
    zho: formatTranslationMessages('zho', mergeMessages(zho, vtmZho)),
    sv: formatTranslationMessages('sv', mergeMessages(sv, vtmSv)),
    no: formatTranslationMessages('no', mergeMessages(no, vtmNo)),
  }
}

export { translationMessages, defaultLocale, supportedLocales }
